import { Table } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from '../../components/Loader';
import { PageHeader } from '../../components/PageHeader';

import { defaultPageSize } from '../../settings/settings';

import { useUserListColumns } from './useUserListColumns';
import { useUserListData } from './useUserListData';

export const Users = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const { userListData, userListTotal, loading } = useUserListData();
  const columns = useUserListColumns();

  return (
    <>
      <PageHeader titleTranslationKey='users.users' />
      <Loader loading={loading}>
        <Table
          rowKey='_id'
          tableLayout='auto'
          dataSource={userListData}
          columns={columns}
          loading={loading}
          scroll={{ x: 'max-content' }}
          pagination={{
            current: page,
            pageSize: defaultPageSize,
            total: userListTotal,
            showTotal: total => t('global.tableTotal', { total }),
            showSizeChanger: false,
            hideOnSinglePage: true,
            onChange: setPage,
          }}
        />
      </Loader>
    </>
  );
};
